import { api, ApiRequestConfig } from 'api';
import { Shop } from 'modules/shops';
import { State, Store } from 'store/types';
import { GlobalEvents } from '../global';
import { FETCH_SERVICE_LIST, FETCH_SERVICE_PRICE_LIST } from './services-constants';
import { Service } from './services-types';

/**
 * Запрос загрузки списка сервисов
 * @param {Shop} shopList
 * @param {string} serviceId
 * @param {ApiRequestConfig} config
 * @returns {Promise<Service[]>}
 */
export const requestServiceList = (
  shopList: Shop,
  serviceId: string,
  { orchestratorHost, useCredentials, apiKey, requestID }: ApiRequestConfig
): Promise<Service[]> => {
  const storeCodes = Object.keys(shopList).map(key => key);

  return api.get<Service[]>(
    'services-availability',
    { serviceId, storeCodes: storeCodes.join() },
    { orchestratorHost, useCredentials, apiKey, requestID }
  );
};

/**
 * Экшен запроса загрузки списка сервисов
 * @param {Store} store
 * @param {string} serviceId
 * @returns {Promise<State>}
 */
export const loadServiceListAction = (store: Store, serviceId: string) =>
  new Promise<State>(resolve => {
    const { modelJson, shops } = store.get();
    if (!modelJson.model || !shops.shopList) {
      resolve(store.get());
      return;
    }

    store.dispatch(GlobalEvents.setRequestParams, {
      orchestratorHost: process.env.ORCHESTRATOR_HOST,
      apiKey: process.env.API_KEY,
    });

    store.dispatch(FETCH_SERVICE_LIST.init, serviceId);

    const unsub = store.on('@dispatch', state => {
      if (state.services?.loading) {
        return;
      }

      unsub();
      resolve(store.get());
    });
  });

/**
 * Запрос загрузки цен для услуг
 * @param {Shop} shopList
 * @param {string[]} serviceTypeIdList
 * @param {ApiRequestConfig} config
 * @returns {Promise<Service[]>}
 */
export const requestServicePriceList = (
  shopList: Shop,
  serviceTypeIdList: string[],
  { orchestratorHost, useCredentials, apiKey, requestID }: ApiRequestConfig
): Promise<Service[][]> => {
  const shopListAr = Object.entries(shopList).filter(store => store[1].name.values[0].includes('Лемана '));
  const shopListFinal = Object.fromEntries(shopListAr);
  const storeCodes = Object.keys(shopListFinal);

  const requests = serviceTypeIdList.map((serviceId: string) =>
    api.get<Service[]>(
      'services-availability',
      { serviceId, storeCodes: storeCodes[0] },
      { orchestratorHost, useCredentials, apiKey, requestID }
    )
  );

  return Promise.all(requests);
};

/**
 * Экшен запроса загрузки цен для услуг
 * @param {Store} store
 * @param {string[]} serviceTypeIdList
 * @returns {Promise<State>}
 */
export const loadServicePriceListAction = (store: Store, serviceTypeIdList: string[]) =>
  new Promise<State>(resolve => {
    const { modelJson, shops } = store.get();
    if (!modelJson.model || !shops.shopList) {
      resolve(store.get());
      return;
    }

    store.dispatch(GlobalEvents.setRequestParams, {
      orchestratorHost: process.env.ORCHESTRATOR_HOST,
      apiKey: process.env.API_KEY,
    });

    store.dispatch(FETCH_SERVICE_PRICE_LIST.init, serviceTypeIdList);

    const unsub = store.on('@dispatch', state => {
      if (state.services?.servicePriceLoading) {
        return;
      }

      unsub();
      resolve(store.get());
    });
  });
